import { Box, Typography } from '@mui/material';

const InvoicePreviewField = ({ label, value, highlight = false }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        color: 'primary.main',
        fontWeight: 800,
        lineHeight: 1.2,
        mb: 0.25,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        color: highlight ? 'text.primary' : 'text.secondary',
        fontWeight: highlight ? 800 : 600,
        lineHeight: 1.25,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      title={String(value || '-')}
    >
      {value || '-'}
    </Typography>
  </Box>
);

export default InvoicePreviewField;
